import Alpine from 'alpinejs';
import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';

// swiper
document.addEventListener('DOMContentLoaded', function() {

    if (document.querySelector('.slider-swiper')) {
        const bannerSwiper = new Swiper('.swiper-container', {
            modules: [Navigation, Autoplay],
            loop: true,
            slidesPerView: 1,
            effect: 'slide',
            speed: 800,
            grabCursor: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: true,
            },
            navigation: {
                nextEl: '.swiper-button-next-custom',
                prevEl: '.swiper-button-prev-custom',
            },
        });
    }

    if (document.querySelector('.product-swiper')) {
        const productSwiper = new Swiper('.product-swiper', {
            modules: [Navigation, Autoplay],
            loop: true,
            slidesPerView: 1,
            effect: 'slide',
            speed: 800,
            grabCursor: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: true,
            },
            navigation: {
                nextEl: '.swiper-button-next-custom',
                prevEl: '.swiper-button-prev-custom',
            },
        });
    }

    if (document.querySelector('.timeline-swiper')) {
        const timelineSwiper = new Swiper('.timeline-swiper', {
            modules: [Navigation],
            loop: false, // No infinite scroll
            autoplay: false, // No autoplay
            effect: 'slide',
            speed: 800,
            grabCursor: true,
            slidesPerView: 1,
            spaceBetween: 20,
            slidesPerGroup: 1,
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                }
            },
            navigation: {
                nextEl: '.swiper-button-next-custom',
                prevEl: '.swiper-button-prev-custom',
            },

        });
    }

});

window.Alpine = Alpine;
Alpine.start();